import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetDimensionalityOptions } from 'constants/businessTool';

import { useGetCurrencySymbol } from 'hooks/useGetCurrencySymbol';

import { IMonetaryUnitsSelectorProps } from './types';
import { BaseSelector } from '../BaseSelector/BaseSelector';

export const MonetaryUnitsSelector: FC<IMonetaryUnitsSelectorProps> = ({ name, disabled }) => {
  const { t } = useTranslation();
  const currencySymbol = useGetCurrencySymbol();
  const DIMENSIONALITY_OPTIONS = useGetDimensionalityOptions();
  return (
    <BaseSelector
      name={name}
      disabled={disabled}
      options={DIMENSIONALITY_OPTIONS}
      defaultValue={DIMENSIONALITY_OPTIONS[0].value}
      label={`${t('monetaryUnits')} (${currencySymbol})`}
    />
  );
};
